import React from "react";
import { FaHourglassHalf, FaClock, FaCheckCircle } from "react-icons/fa";


export const makeAssType_30 = ({ book, user }) => ({
    5: {
        STEP1: {
            review_link: book.selectedCurrentUserAssign?.review_link || "Not found",
            // ===== Short step cards =====
            icon1: <FaHourglassHalf className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite" size={15} />,
            title1: "Open link and mark Helpful",
            description1: "Use the link below to open the target review. Tap “Helpful”, then click the “Next Step” button.",

            icon2: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title2: "Upload proof of action",
            description2: "Upload a clear screenshot showing your “Helpful” mark together with the review content.",

            icon3: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "Submit the assignment. Verification will be completed after we review your uploaded file.",

            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title4: "Approve assignment",
            description4: "We are waiting for you to finish the previous three steps. Then we can approve your task.",

            // ===== Expanded step panels =====
            full_title1: `Go to the assigned Amazon review, click “Helpful”, and take a clear screenshot.`,
            full_subtitle1: "Make sure you're logged into your Amazon reviewer account before marking it Helpful.",
            full_description1: (
                <p>
                    Open the <b>exact review link</b> provided in this assignment and click the <b>“Helpful”</b> button under that review.
                    Ensure your action is registered, then <b>take a clear screenshot</b> showing the review and your mark.
                    Use the button below to open the review page and proceed.
                </p>
            ),


            full_title2: "Upload your “Helpful” screenshot",
            full_subtitle2: "The review and the “Thank you for your feedback” message must be visible.",
            full_description2: (
                <p>
                    Please upload a <b>clear screenshot</b> of the review section showing that you clicked <b>“Helpful”</b>.
                    The confirmation text <b>“Thank you for your feedback.”</b> should be visible on the screen.
                    Make sure the image is not blurry or cropped, otherwise it may be rejected.
                </p>
            ),


            full_title3: "Turn in this assignment",
            full_subtitle3: "After uploading your proof, please submit this assignment so that our team can begin the verification process.",
            full_description3: (
                <p>
                    Click the button below to submit. Our team will verify your screenshot and confirm the action on Amazon.
                    If anything is missing, we’ll ask you to re-upload or provide additional details.
                </p>
            ),

            full_title4: "Awaiting verification",
            full_subtitle4: "We’ll review your screenshot and finalize this assignment.",
            full_description4: (
                <p>
                    Once the proof is confirmed, we’ll record it and mark the assignment as completed.
                    Thank you for taking the time to document this and helping us maintain review integrity!
                </p>
            ),

        },
        STEP2: {
            review_link: book.selectedCurrentUserAssign?.review_link || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title1: "Open link and mark Helpful",
            description1: "You have completed this step!",

            icon2: <FaHourglassHalf className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite" size={15}/>,
            title2: "Upload proof of action",
            description2: "Upload a clear screenshot showing your “Helpful” mark together with the review content.",

            icon3: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "Submit the assignment. Verification will be completed after we review your uploaded file.",

            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title4: "Approve assignment",
            description4: "We are waiting for you to finish the previous three steps. Then we can approve your task.",

            // ===== Expanded step panels =====
            full_title1: "",
            full_subtitle1: "",
            full_description1: "",

            full_title2: "Upload your “Helpful” screenshot",
            full_subtitle2: "The review and the “Thank you for your feedback” message must be visible.",
            full_description2: (
                <p>
                    Please upload a <b>clear screenshot</b> of the review section showing that you clicked <b>“Helpful”</b>.
                    The confirmation text <b>“Thank you for your feedback.”</b> should be visible on the screen.
                    Make sure the image is not blurry or cropped, otherwise it may be rejected.
                </p>
            ),

            full_title3: "Turn in this assignment",
            full_subtitle3: "After uploading your proof, please submit this assignment so that our team can begin the verification process.",
            full_description3: (
                <p>
                    Click the button below to submit. Our team will verify your screenshot and confirm the action on Amazon.
                    If anything is missing, we’ll ask you to re-upload or provide additional details.
                </p>
            ),

            full_title4: "Awaiting verification",
            full_subtitle4: "We’ll review your screenshot and finalize this assignment.",
            full_description4: (
                <p>
                    Once the proof is confirmed, we’ll record it and mark the assignment as completed.
                    Thank you for taking the time to document this and helping us maintain review integrity!
                </p>
            ),

        },
        STEP3: {
            review_link: book.selectedCurrentUserAssign?.review_link || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title1: "Open link and mark Helpful",
            description1: "You have completed this step!",

            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title2: "Upload proof of action",
            description2: "Your proof has been successfully uploaded — excellent work completing this step! Keep it up!",

            icon3: <FaHourglassHalf className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite" size={15} />,
            title3: "Turn in this assignment",
            description3: "Submit the assignment. Verification will be completed after we review your uploaded file.",

            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title4: "Approve assignment",
            description4: "We are waiting for you to finish the previous three steps. Then we can approve your task.",

            // ===== Expanded step panels =====
            full_title1: "",
            full_subtitle1: "",
            full_description1: "",

            full_title2: "",
            full_subtitle2: "",
            full_description2: "",

            full_title3: "Turn in this assignment",
            full_subtitle3: "After uploading your proof, please submit this assignment so that our team can begin the verification process.",
            full_description3: (
                <p>
                    Click the button below to submit. Our team will verify your screenshot and confirm the action on Amazon.
                    If anything is missing, we’ll ask you to re-upload or provide additional details.
                </p>
            ),

            full_title4: "Awaiting verification",
            full_subtitle4: "We’ll review your screenshot and finalize this assignment.",
            full_description4: (
                <p>
                    Once the proof is confirmed, we’ll record it and mark the assignment as completed.
                    Thank you for taking the time to document this and helping us maintain review integrity!
                </p>
            ),

        },
        STEP4: {
            review_link: book.selectedCurrentUserAssign?.review_link || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title1: "Open link and mark Helpful",
            description1: "You have completed this step!",

            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title2: "Upload proof of action",
            description2: "Your proof has been successfully uploaded — excellent work completing this step! Keep it up!",

            icon3: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "Your assignment has been submitted! You’ll be notified once the assignment is complete.",

            icon4: <FaHourglassHalf className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite" size={15} />,
            title4: "Approve assignment",
            description4: "We are waiting for you to finish the previous three steps. Then we can approve your task.",

            // ===== Expanded step panels =====
            full_title1: "",
            full_subtitle1: "",
            full_description1: "",

            full_title2: "",
            full_subtitle2: "",
            full_description2: "",

            full_title3: "",
            full_subtitle3: "",
            full_description3: "",

            full_title4: "Awaiting verification",
            full_subtitle4: "We’ll review your screenshot and finalize this assignment.",
            full_description4: (
                <p>
                    Once the proof is confirmed, we’ll record it and mark the assignment as completed.
                    Thank you for taking the time to document this and helping us maintain review integrity!
                </p>
            ),

        },
        STEP5: {
            review_link: book.selectedCurrentUserAssign?.review_link || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title1: "Open link and mark Helpful",
            description1: "You have completed this step!",

            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title2: "Upload proof of action",
            description2: "Your proof has been successfully uploaded — excellent work completing this step! Keep it up!",

            icon3: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "Your assignment has been submitted! You’ll be notified once the assignment is complete.",

            icon4: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title4: "Assignment confirmed!",
            description4: "Congratulations, your assignment is fully confirmed! excellent work completing this task!",

            // ===== Expanded step panels =====
            full_title5: "Assignment closed and verified!",
            full_subtitle5: "Everything looks good — the assignment has been finalized.",
            full_description5: (
                <p>
                    This assignment has passed verification and is now officially closed.
                    The corresponding <b>Virt</b> reward was credited at the moment you took the assignment.
                    Thank you for providing proof and completing the verification process!
                </p>
            ),

        },
    },
});
